import { createSelector } from '@reduxjs/toolkit'
import { customMigrationKey, defaultState } from './reducers'
import { pathOr } from 'ramda'
import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import moment from 'moment'

const dateFormat = 'ddd D MMM h:mm A'

export const migrationsSelector = createSelector(
  (state) => pathOr(defaultState, [customMigrationKey])(state),
  (result) => {
    return result
  },
)

export const vmMigrationsSelector = createSharedSelector(
  getDataSelector<DataKeys.VmMigrations>(DataKeys.VmMigrations),
  (migrations) => {
    return migrations
      .filter((migration) => ['migration', 'live-migration'].includes(migration?.migration_type))
      .map((migration) => {
        const createdTimestamp = `${migration?.created_at?.split('.')?.[0]}Z`
        const updatedTimestamp = `${migration?.updated_at?.split('.')?.[0]}Z`
        // any model changes go here
        return {
          createdTimestamp,
          updatedTimestamp,
          createdTimeString: moment(createdTimestamp).format(dateFormat),
          updatedTimeString: moment(updatedTimestamp).format(dateFormat),
          ...migration,
        }
      })
  },
)

export const latestMigrationByVmSelector = createSharedSelector(
  vmMigrationsSelector,
  (migrations) => {
    const migrationsByVmId = migrations.reduce((accum, migration) => {
      // Only want latest a VM's latest migration
      if (
        accum[migration?.instance_uuid] &&
        accum[migration?.instance_uuid].createdTimestamp > migration?.createdTimestamp
      ) {
        return accum
      }
      return {
        ...accum,
        [migration?.instance_uuid]: migration,
      }
    }, {})
    return migrationsByVmId
  },
)
